import { useState, createContext, useMemo } from 'react';

const context = {};

export const PerformanceFiltersContext = createContext(context);

export function PerformanceFiltersContextProvider(props) {
  const [filterToggle, setFilterToggle] = useState(false);
  const [filterValue, setFilterValue] = useState('');
  const [checkBoxData, setCheckBoxData] = useState([]);
  const [comparePageSelection, setComparePageSelection] = useState({});
  const [selectedType, setSelectedType] = useState({
    category: false,
    brand: false,
    product: false,
    campaign: false,
  });
  const [compareGraphsData, setCompareGraphsData] = useState({});
  const toggleFilter = () => {
    setFilterToggle(!filterToggle);
  };
  const contextValues = useMemo(
    () => ({
      filterState: filterValue,
      toggleFilter,
      checkBoxData,
      comparePageSelection,
      compareGraphsData,
      selectedType,
      setFilterValue,
      setCheckBoxData,
      setComparePageSelection,
      setCompareGraphsData,
      setSelectedType,
    }),
    [filterToggle, toggleFilter],
  );
  return (
    <PerformanceFiltersContext.Provider value={contextValues}>{props.children}</PerformanceFiltersContext.Provider>
  );
}
